/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_NotetakerInputs */



/**
* | output |
* | --- |
* | "Wundo writes the report too" |
*
* @param {Onboarding_NotetakerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_notetaker = /** @type {((inputs?: Onboarding_NotetakerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_NotetakerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo maakt ook het verslag")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo rédige aussi le compte rendu")
	return /** @type {LocalizedString} */ ("Wundo writes the report too")
});